import store from "@/store";
import redirectToHomeMiddleware from "@/router/middlewares/redirectToHomeMiddleware";
import { IS_DEV, AUTH_URL } from "@/config";

export default ({ next, router }) => {
  const isAuthenticated = !!store.getters.user;
  if (isAuthenticated) {
    return redirectToHomeMiddleware({ next, router });
  } else if (!IS_DEV) {
    return (window.location.href = AUTH_URL);
  }
  return next();
};
